import React from 'react';
import {useParams} from 'react-router-dom';
import { NavLink } from "react-router-dom";
import RecordDetails from "components/recordDetails/RecordDetails";

export function Details(props){

  
  const {id} = useParams();

  return (
    <>
    <nav className='subnav'>

    <NavLink exact to='/client/logs/cleanup' activeClassName='active'>Cleanup</NavLink>
    {/* <NavLink exact to='/client/monitors/rules' activeClassName='active'>Alerts</NavLink> */}
    <NavLink  to='/client/monitors/details' activeClassName='active'>Details</NavLink>
    </nav>

        {/* <Breadcrumbs items={[
          { name: 'Logs', url: '/client/logs' },
          { name: 'Record Details', url: '#' }
        ]}/> */}
        <RecordDetails id={id} />
       

    </>
  );
}



